import { MarketType } from '@drift-labs/sdk';
import { UIMarket, USER_UTILS } from '@drift/common';
import useMarketSettingsStore from 'src/stores/useMarketSettingsStore';
import useMarketMaxLeverage from 'src/hooks/useMarketMaxLeverages';
import useCurrentUserAccount from './useCurrentUserAccount';

/**
 * Hook that calculates the display leverage for a market position.
 * Handles gathering all necessary data from stores and other hooks.
 */
export default function useGetDisplayLeverageForMarket(
	marketIndex: number | undefined
): number {
	const symbol = UIMarket.createPerpMarket(marketIndex ?? 0).symbol;

	const savedMaxLev = useMarketSettingsStore((s) =>
		s.getMaxLeverageForMarket(symbol)
	);

	const { maxLeverage, highLeverageMaxLeverage, hasHighLeverage } =
		useMarketMaxLeverage(MarketType.PERP, marketIndex);

	const user = useCurrentUserAccount()?.client;

	return USER_UTILS.getUserMaxLeverageForMarket(
		user,
		marketIndex ?? 0,
		{
			regularMaxLeverage: maxLeverage,
			highLeverageMaxLeverage,
			hasHighLeverage,
		},
		savedMaxLev
	);
}
